import { ORG_ROLES } from '@noconflict/contracts';
import { z } from 'zod';
import { validationMessage } from '../../../shared/i18n/zod';

/**
 * The invite form. The address follows the contract's `createInvitationRequestSchema` (trimmed, lower-cased,
 * a valid email) with a catalogue message; workspace roles are held beside the form as a draft map.
 */
export const inviteSchema = z.object({
  email: z
    .string()
    .trim()
    .toLowerCase()
    .pipe(z.email(validationMessage('email')).max(254, validationMessage('email'))),
  orgRole: z.enum(ORG_ROLES),
});
export type InviteInput = z.input<typeof inviteSchema>;
export type InviteValues = z.output<typeof inviteSchema>;
